export enum VideoUploadError {
  MAX_VIDEO_SIZE = 'MAX_VIDEO_SIZE',
  GET_PRE_SIGN_LINKS = 'GET_PRE_SIGN_LINKS',
  UNABLE_TO_UPLOAD_CHUNK = 'UNABLE_TO_UPLOAD_CHUNK',
  UNABLE_TO_COMPLETE_TASK = 'UNABLE_TO_COMPLETE_TASK',
}
